<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['department', 'com_name', 'rank', 'writer_name', 'date']">
      <template #after-custom-row>
        <vs-row class="mb-4" style="display: grid; grid-template-columns: 114px 1fr" vs-align="center">
          <vs-col class="label-text mr-4">분야명</vs-col>
          <vs-col>
            <div v-if="isPrint" class="print-input">{{ form.stdInfo.field_name }}</div>
            <ml-input v-else class="w-full" :value="form.stdInfo.field_name" :readonly="true" />
          </vs-col>
        </vs-row>
      </template>
    </field-select-module>

    <!-- 신규 사업장 개요 -->
    <div>
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 신규 시설물 개요</h5>
        </vs-col>
      </vs-row>
      <div class="w-full grid" style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">시설물명</div>
          <p v-if="isPrint" class="print-input">{{ form.field_name }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.field_name" placeholder="입력해 주세요" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">담당 주무관</div>
          <p v-if="isPrint" class="print-input">{{ form.director_name }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.director_name" placeholder="입력해 주세요" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">준공일</div>
          <p v-if="isPrint" class="print-input">{{ form.be_completed_at }}</p>
          <date-selector v-else :readonly="board.readonly" class="w-full flex-1" v-model="form.be_completed_at" placeholder="날짜선택" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">사업금액</div>
          <p v-if="isPrint" class="print-input">{{ form.deposit_amount }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.deposit_amount" placeholder="입력해 주세요" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">시설물 위치(주소)</div>
          <p v-if="isPrint" class="print-input">{{ form.address }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.address" placeholder="입력해 주세요" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center"></div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">구분</div>
          <p v-if="isPrint" class="print-input">{{ form.cat1 }}</p>
          <ml-input v-else-if="board.readonly" :readonly="board.readonly" v-model="form.cat1" placeholder="입력해 주세요" class="w-full flex-1" />
          <vs-select v-else class="w-full" autocomplete v-model="form.cat1" @change="onChangeCat1">
            <vs-select-item v-for="option in cat1List" :key="option.cat1" :text="option.cat1" :value="option.cat1" />
          </vs-select>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">종류</div>
          <p v-if="isPrint" class="print-input">{{ form.cat2 }}</p>
          <ml-input v-else-if="board.readonly" :readonly="board.readonly" v-model="form.cat2" placeholder="입력해 주세요" class="w-full flex-1" />
          <vs-select v-else class="w-full" autocomplete v-model="form.cat2" @change="onChangeCat2">
            <vs-select-item v-for="option in cat2List" :key="option.cat2" :text="option.cat2" :value="option.cat2" />
          </vs-select>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">세분류</div>
          <p v-if="isPrint" class="print-input">{{ form.cat3 }}</p>
          <ml-input v-else-if="board.readonly" :readonly="board.readonly" v-model="form.cat3" placeholder="입력해 주세요" class="w-full flex-1" />
          <vs-select v-else class="w-full" autocomplete v-model="form.cat3" @change="onChangeCat3">
            <vs-select-item v-for="option in cat3List" :key="option.cat3" :text="option.cat3" :value="option.cat3" />
          </vs-select>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">종별</div>
          <p v-if="isPrint" class="print-input">{{ form.cat4 }}</p>
          <ml-input v-else-if="board.readonly" :readonly="board.readonly" v-model="form.cat4" placeholder="입력해 주세요" class="w-full flex-1" />
          <vs-select v-else class="w-full" autocomplete v-model="form.cat4" @change="onChangeCat4">
            <vs-select-item v-for="option in cat4List" :key="option.classification" :text="option.classification" :value="option.id" />
          </vs-select>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">안전 등급</div>
          <p v-if="isPrint" class="print-input">{{ form.safety_grade }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.safety_grade" placeholder="입력해 주세요" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">형식</div>
          <p v-if="isPrint" class="print-input">{{ form.format }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.format" placeholder="입력해 주세요" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">규모1</div>
          <p v-if="isPrint" class="print-input">{{ form.scale1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.scale1" placeholder="입력해 주세요" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">규모2</div>
          <p v-if="isPrint" class="print-input">{{ form.scale2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.scale2" placeholder="입력해 주세요" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">규모3</div>
          <p v-if="isPrint" class="print-input">{{ form.scale3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.scale3" placeholder="입력해 주세요" class="w-full flex-1" />
        </div>
      </div>
    </div>

    <!-- 수급업체 정보 -->
    <FieldWorkplaceTable :readonly="board.readonly" :isPrint="isPrint" v-model="form.infoDatas" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldWorkplaceTable from "@/components/FieldWorkplaceTable.vue";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    FieldSelectModule,
    FieldWorkplaceTable,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        field_name: "", // 사업장명
        director_name: "", // 담당 주무관
        be_completed_at: "", // 준공일
        deposit_amount: "", // 사업금액
        address: "", //시설물 위치(주소)

        cat1: "", // 구분
        cat2: "", // 종류
        cat3: "", // 세분류
        cat4: "", // 종별

        safety_grade: "", // 안전등급
        format: "", // 형식
        scale1: "", // 규모1
        scale2: "", // 규모2
        scale3: "", // 규모3
        facility_category_id: "",

        infoDatas: [],
      },

      cat1List: [],
      cat2List: [],
      cat3List: [],
      cat4List: [],
    };
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    projectInfo: {
      immediate: true,
      deep: true,
      handler(value) {
        if (!this.form.stdInfo.field_name) this.form.stdInfo.field_name = this.projectInfo.field_name;
      },
    },
  },
  async mounted() {
    await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", {});
    this.cat1List = this.$store.state.project.fieldFacilityCategoryOptions;
  },
  methods: {
    async onChangeCat1(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: data });
        this.cat2List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
    async onChangeCat2(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.form.cat1, cat2: data });
        this.cat3List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
    async onChangeCat3(data) {
      if (data) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.form.cat1, cat2: this.form.cat2, cat3: data });
        this.cat4List = this.$store.state.project.fieldFacilityCategoryOptions;
      }
    },
    onChangeCat4(data) {
      this.form.facility_category_id = data;
    },
  },
};
</script>

<style scoped lang="scss"></style>
